import {useState} from 'react'


const ZoomImgLogique = ()=>{

    const [affiche, setAffiche] = useState(false);

    function toggle(){
        setAffiche(!affiche)
    }

    return {
        affiche, 
        toggle
}

}

export default ZoomImgLogique;